export const dashboard = {
    path: '/dashboard',
    name: 'dashboard',
    hidden: false,
    component: () =>
        import ('@/components/dashboard/index'),
    meta: {
        title: 'Dashboard',
        icon: 'fa-home',
        roles: ['member']
    },
}
export default dashboard


// WEBPACK FOOTER //
// ./src/router/modules/dashboard.js